import { reactive, watchEffect } from '@vue/composition-api';

import { Menu } from '@/types';
import { filterMenus } from '@/filemenu/utils';
import { helpDialog, reportIssuesDialog } from './state';

const help: Menu = {
  text: 'Help',
  click: () => { helpDialog.value = true; },
  hotkey: 'F1',
};

const reportIssues: Menu = {
  text: 'Report Issues',
  click: () => { reportIssuesDialog.value = true; },
};

// Order will be preserved
const allMenus = [
  help,
  reportIssues,
];

export const menu = reactive({
  text: 'About',
  menu_width: 180,
  menu: [] as Menu[],
});

// Enable/disable menu items based on user level
watchEffect(() => {
  // Filter allowed menus
  menu.menu = filterMenus(allMenus);
});
